import { render, staticRenderFns } from "./AdminUserList.vue?vue&type=template&id=2f4baa30&scoped=true"
import script from "./AdminUserList.vue?vue&type=script&lang=js"
export * from "./AdminUserList.vue?vue&type=script&lang=js"
import style0 from "./AdminUserList.vue?vue&type=style&index=0&id=2f4baa30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4baa30",
  null
  
)

export default component.exports